import React, { Component } from 'react'
import { isSet } from '../../utils/commonUtils'
import FormInputs from '../../components/UI/FormInputs';

export default class Billing extends Component {
           constructor(props) {
                super(props);
                // Initialize state 
                this.state = {
                    activeTab:"1",
                }
    }
  render() {
    const {validations,formData,onChangeHandler,isEmployerView}=this.props
    const inputFields=this.getInputFieldsTab3()
    return (
      <>
      {inputFields.map((section, secIndex) => {
                return (
                    <div className="card mb-2" key={secIndex}>
                        <a href={`#collapseCardExample_${secIndex}`} className="d-block sh_accordionheader card-header" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseCardExample" style={{ position: 'sticky', top: '-20px', zIndex: '1' }}>
                            <h6 className="mb-0 text-md">{section.title}</h6>
                        </a>
                        <div className="collapse show" id={`collapseCardExample_${secIndex}`} data-bs-parent="#modal111">
                            <div className="card-body">
                                <div className="row">
                                    {section.data.map((item, itemIndex) => {
                                    //   if (isSet(item.isShow, true) === false) { return false }
                                        const value = isSet(formData[item.name],'');
                                        return (
                                            <div className="col-sm-12" key={itemIndex}>
                                                <div className="form-group row">
                                                    <label className="col-sm-3 col-form-label opacity-75">{item.label}</label>
                                                    <div className="col-sm-9">
                                                      {isSet(item.isLabelAppend,false)===true?
                                                      <div className="form-check">
                                                        <FormInputs {...item} value={value} changeHandler={(val,e)=>{onChangeHandler(item.name,val,e); }} />
                                                        { (isSet(validations[item.name], '') !== '' ? <span className="text-danger m-1">{isSet(validations[item.name], '')}</span> : '')}                                                        
                                                      </div>
                                                      :<>
                                                      <FormInputs {...item} value={value} changeHandler={(val,e,label)=>{onChangeHandler(item.name,val,e,label) }}/>
                                                        { (isSet(validations[item.name], '') !== '' ? <span className="text-danger m-1">{isSet(validations[item.name], '')}</span> : '')}                                                     
                                                      </> } 

                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        
    </>
    )
  }
  getInputFieldsTab3 = () => {
    const { isEmployerView } = this.props;
    const allSections = [
       {
        title: 'Diagnosis - ICD10',
        data: [
          {
            type: "SelectSearchFields",
            displayValue:this.props.formData['diagnosis_1_label'],
            label: "Diagnosis 1",
            placeholder: "Diagnosis 1",
            className: "form-control form-control-solid",
            name: "diagnosis_1",
            col: 'col-6',
            options:this.props.icd10List,
            isAsync:true,
            isCacheNeeded:false,
            loadCallBack:(val, callback) =>this.props.fetchIcd10List(val, callback)
          },
          {
            type: "SelectSearchFields",
            displayValue:this.props.formData['diagnosis_2_label'],
            label: "Diagnosis 2",
            placeholder: "Diagnosis 2",
            className: "form-control form-control-solid",
            name: "diagnosis_2",
            col: 'col-6',
            options:this.props.icd10List,
            isAsync:true,
            isCacheNeeded:false,
            loadCallBack:(val, callback) =>this.props.fetchIcd10List(val, callback)
          },
          {
            type: "SelectSearchFields",
            displayValue:this.props.formData['diagnosis_3_label'],
            label: "Diagnosis 3",
            placeholder: "Diagnosis 3",
            className: "form-control form-control-solid",
            name: "diagnosis_3",
            col: 'col-6',
            options:this.props.icd10List,
            isAsync:true,
            isCacheNeeded:false,
            loadCallBack:(val, callback) =>this.props.fetchIcd10List(val, callback)
          }, {
            type: "SelectSearchFields",
            displayValue:this.props.formData['diagnosis_4_label'],
            label: "Diagnosis 4",
            placeholder: "Diagnosis 4",
            className: "form-control form-control-solid",
            name: "diagnosis_4",
            col: 'col-6',
            options:this.props.icd10List,
            isAsync:true,
            isCacheNeeded:false,
            loadCallBack:(val, callback) =>this.props.fetchIcd10List(val, callback)
          }, {
            type: "SelectSearchFields",
            displayValue:this.props.formData['diagnosis_5_label'],
            label: "Diagnosis 5",
            placeholder: "Diagnosis 5",
            className: "form-control form-control-solid",
            name: "diagnosis_5",
            col: 'col-6',
            options:this.props.icd10List,
            isAsync:true,
            isCacheNeeded:false,
            loadCallBack:(val, callback) =>this.props.fetchIcd10List(val, callback)
          }, {
            type: "SelectSearchFields",
            displayValue:this.props.formData['diagnosis_6_label'],
            label: "Diagnosis 6",
            placeholder: "Diagnosis 6",
            className: "form-control form-control-solid",
            name: "diagnosis_6",
            col: 'col-6',
            options:this.props.icd10List,
            isAsync:true,
            isCacheNeeded:false,
            loadCallBack:(val, callback) =>this.props.fetchIcd10List(val, callback)
          }, {
            type: "SelectSearchFields",
            displayValue:this.props.formData['diagnosis_7_label'],
            label: "Diagnosis 7",
            placeholder: "Diagnosis 7",
            className: "form-control form-control-solid",
            name: "diagnosis_7",
            col: 'col-6',
            options:this.props.icd10List,
            isAsync:true,
            isCacheNeeded:false,
            loadCallBack:(val, callback) =>this.props.fetchIcd10List(val, callback)
          }, {
            type: "SelectSearchFields",
            displayValue:this.props.formData['diagnosis_8_label'],
            label: "Diagnosis 8",
            placeholder: "Diagnosis 8",
            className: "form-control form-control-solid",
            name: "diagnosis_8",
            col: 'col-6',
            options:this.props.icd10List,
            isAsync:true,
            isCacheNeeded:false,
            loadCallBack:(val, callback) =>this.props.fetchIcd10List(val, callback)
          }, {
            type: "SelectSearchFields",
            displayValue:this.props.formData['diagnosis_9_label'],
            label: "Diagnosis 9",
            placeholder: "Diagnosis 9",
            className: "form-control form-control-solid",
            name: "diagnosis_9",
            col: 'col-6',
            options:this.props.icd10List,
            isAsync:true,
            isCacheNeeded:false,
            loadCallBack:(val, callback) =>this.props.fetchIcd10List(val, callback)
          }, {
            type: "SelectSearchFields",
            displayValue:this.props.formData['diagnosis_10_label'],
            label: "Diagnosis 10",
            placeholder: "Diagnosis 10",
            className: "form-control form-control-solid",
            name: "diagnosis_10",
            col: 'col-6',
            options:this.props.icd10List,
            isAsync:true,
            isCacheNeeded:false,
            loadCallBack:(val, callback) =>this.props.fetchIcd10List(val, callback)
          }, {
            type: "SelectSearchFields",
            displayValue:this.props.formData['diagnosis_11_label'],
            label: "Diagnosis 11",
            placeholder: "Diagnosis 11",
            className: "form-control form-control-solid",
            name: "diagnosis_11",
            col: 'col-6',
            options:this.props.icd10List,
            isAsync:true,
            isCacheNeeded:false,
            loadCallBack:(val, callback) =>this.props.fetchIcd10List(val, callback)
          }, {
            type: "SelectSearchFields",
            displayValue:this.props.formData['diagnosis_12_label'],
            label: "Diagnosis 12",
            placeholder: "Diagnosis 12",
            className: "form-control form-control-solid",
            name: "diagnosis_12",
            col: 'col-6',
            options:this.props.icd10List,
            isAsync:true,
            isCacheNeeded:false,
            loadCallBack:(val, callback) =>this.props.fetchIcd10List(val, callback)
          },
        ]
      },
      {
        title: 'Employer - Carrier Information',
        data: [
          {
            type: "SelectList",
            label: "Employer Name",
            placeholder: "Employer Name",
            className: "form-control form-control-solid",
            name: "employer_id",
            col: 'col-6',
            options:this.props.companyList
          },
          {
            type: "Phone",
            label: "Employer Phone",
            placeholder: "Employer Phone",
            className: "form-control form-control-solid",
            name: "employer_phone",
            col: 'col-6',
            readOnly:true,
          },
            {
            type: "SelectSearchList",
            label: "Self Insured - Bill Employer",
            placeholder: "Self Insured - Bill Employer:",
            className: "form-control form-control-solid",
            name: "self_insured_bill_employer",
            col: 'col-6',
            options: this.props.providerOptions,
          },
          {
            type: "SelectList",
            label: "Work Comp Insurance / TPA",
            placeholder: "Work Comp Insurance / TPA",
            className: "form-control form-control-solid",
            name: "work_comp_insurance_tpa",
            col: 'col-6',
            options:this.props.workCompInsuranceList,
          },
            {
            type: "TextInput",
            label: "Policy Number",
            placeholder: "Policy Number",
            className: "form-control form-control-solid",
            name: "policy_number",
            col: 'col-6',
          }, {
            type: "SelectList",
            label: "Policy Expiration",
            placeholder: "Policy Expiration",
            className: "form-control form-control-solid",
            name: "policy_expiration",
            col: 'col-6',
            options:this.props.LookupList["policy_expiration"],
          }, {
            type: "Date",
            label: "Billing from Date",
            placeholder: "Billing from Date:",
            className: "form-control form-control-solid",
            name: "billing_from_date",
            col: 'col-6',
          },
            {
            type: "Date",
            label: "Declined Date",
            placeholder: "Declined Date",
            className: "form-control form-control-solid",
            name: "billing_declined_date",
            col: 'col-6',
          },           
        ]
      },
      {
        title: 'Billing Overides by Visit Type',
        data: [
          {
            type: "SelectList",
            label: "Work Comp Injury",
            placeholder: "Work Comp Injury",
            className: "form-control form-control-solid",
            name: "work_comp_injury",
            col: 'col-6',
            options:this.props.workCompInsuranceList,
          },
           {
            type: "SelectList",
            label: "Physical Therapy",
            placeholder: "Physical Therapy",
            className: "form-control form-control-solid",
            name: "physical_therapy_billing",
            col: 'col-6',
            options:this.props.workCompInsuranceList,
          },
           {
            type: "SelectList",
            label: "Chiropractic",
            placeholder: "chiropractic",
            className: "form-control form-control-solid",
            name: "billing_chiropractic",
            col: 'col-6',
            options:this.props.workCompInsuranceList,
          },
           {
            type: "SelectList",
            label: "Acuptunture",
            placeholder: "acupuncture",
            className: "form-control form-control-solid",
            name: "billing_acupuncture",
            col: 'col-6',
            options:this.props.workCompInsuranceList,
          },
           {
            type: "SelectList",
            label: "Drug Screens",
            placeholder: "Drug Screens",
            className: "form-control form-control-solid",
            name: "drug_screens",
            col: 'col-6',
            options:this.props.workCompInsuranceList,
          },
           {
            type: "SelectList",
            label: "Other",
            placeholder: "Other",
            className: "form-control form-control-solid",
            name: "billing_overide_other",
            col: 'col-6',
            options:this.props.workCompInsuranceList,
          },
           {
            type: "Checkbox",
            label: "Private / Commercial",
            placeholder: "Private / Commercial",
            className: "form-check-input",
            name: "private_commercial",
            col: 'col-6',
            isLabelAppend:true,
          },
        ]
      },
      {
        title: 'Billing Notes',
        data: [
          {
            type: "TextArea",
            label: "Billing Case Notes (specific to this Incident):",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "billing_notes",
            col: 'col-6',
          },
        ]
      },
    ];
    // For employer view, only show "Employer - Carrier Information" and "Billing Notes" sections
    if (isEmployerView) {
      return allSections.filter(section => 
        section.title === 'Employer - Carrier Information' || 
        section.title === 'Billing Notes'
      );
    }
    
    return allSections;
  }
}
